import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import Fuse from "fuse.js"

// Metronic helper to done sorting-table ,select row etc.
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
// import * as uiHelpers from "../UserUIHelper";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { useCategoriesUIContext } from "../CategoriesUIContext";
import { fetchCategories } from "../../../actions/categories/categories";

export function CategoryTable() {

  const [loader, setLoader] = useState(true);

  const { categories } = useSelector(
    (state) => ({
      categories:
        state.categories && state.categories && state.categories.categories&&state.categories.categories.docs,
    }),
    shallowEqual
  );

  console.log(categories)

  const { totalDocs } = useSelector(
    (state) => ({
      totalDocs:
        state.categories && state.categories && state.categories.categories && state.categories.categories.totalDocs,
    }),
    shallowEqual
  );

  const { totalCategories } = useSelector(
    (state) => ({
      totalCategories:
        state.categories && state.categories && state.categories.categories && state.categories.categories.totalCategoryCount,
    }),
    shallowEqual
  ); 

  const dispatch = useDispatch();

  const priceUIContext = useCategoriesUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      setIds: priceUIContext.setIds,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      openEditCategoryPage: priceUIContext.openEditCategoryPage,
    };
  }, [priceUIContext]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleOnChange = (e) => {
    setSearchQuery(e.target.value)
    priceUIProps.setQueryParams((prev) => {return { ...prev, search:e.target.value }})
  }

  useEffect(() => {

    async function getShopifyPricingData () {
      setLoader(true);
      await dispatch(fetchCategories(priceUIProps.queryParams));
      setLoader(false);
    }

    getShopifyPricingData();
  }, [priceUIProps.queryParams, dispatch]);

  
  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];
  
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalDocs===null?0:totalDocs,
    sizePerPageList: sizePerPageList,
    sizePerPage: priceUIProps.queryParams.pageSize,
    page: priceUIProps.queryParams.pageNumber,
  };
  
  const columns = [
    {
      dataField: "index",
      text: "Id",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.RowIndex,
      style: { minWidth: "70px" },
      formatExtraData: {paginationOptions}
    },
    {
      dataField: "category_name",
      text: "Category Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "cart_order",
      text: "Category Order",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
   
    
    // {
    //   dataField: "date",
    //   text: " Created At",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   formatter: columnFormatters.CreateDateColumnFormatter,
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditCategoryPage: priceUIProps.openEditCategoryPage,
        total: totalCategories===null?0:totalCategories
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
    },
  ];


  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <div className="row">
              <div className="col-12">
                  <div class="form-group input-icon" >
                    <input type="email" class="form-control" value={searchQuery} onChange={handleOnChange} placeholder="Search..."></input> <span>
                      <i className="flaticon2-search-1 text-muted"></i>
                    </span>
                  </div>
                </div>

              </div>
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                data={categories === null ? []:categories}
                // data={[]}
                onTableChange={getHandlerTableChange(
                  priceUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => categories === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader &&  <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}
